// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3RLu9","colMin":"styles_colMin__1Kxtv","colCheckbox":"styles_colCheckbox__3xmxl"};